import { Collapse } from 'antd';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { sendArtworktoVendor } from '../../api/order';
import OrderManagerStudio from '../../components/data/studio/orderMangerStudio';
import { Page } from '../../components/page';
const { Panel } = Collapse
const SendDirectArtwork = ({ title }) => {
    const { state } = useLocation();
    const selectedVendorArtworks = useRef(null)
    return (
        <Page title={title}  >
            <Collapse defaultActiveKey={['1']} expandIconPosition="end">
                <Panel header='Customer Artwork' key="1">
                    <OrderManagerStudio data={
                        {
                            data: state,
                            onSubmit: sendArtworktoVendor,
                            text: 'Send to Vendor'
                        }} ref={selectedVendorArtworks}/>
                </Panel>
            </Collapse>
        </Page>
    )
}
SendDirectArtwork.propTypes = {
    title: PropTypes.string,
}
export default SendDirectArtwork